import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import type { HTMLAttributes } from 'react';

type IconProps = Partial<CustomIconComponentProps> & HTMLAttributes<HTMLSpanElement>;

export const SignalIcon = (props: Partial<CustomIconComponentProps>) => {
  const SignalSVG = () => {
    return (
      <svg
        width='20px'
        height='20px'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M13 8H15V20H13V8Z' fill='currentColor' />
        <path d='M5 16H7V20H5V16Z' fill='currentColor' />
        <path d='M9 12H11V20H9V12Z' fill='currentColor' />
        <path d='M17 4H19V20H17V4Z' fill='currentColor' />
      </svg>
    );
  };
  return <Icon component={SignalSVG} {...props} />;
};

export const SettingsIcon = (props: Partial<CustomIconComponentProps>) => {
  const SettingsSVG = () => {
    return (
      <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_761_49394)'>
          <rect width='40' height='40' rx='20' fill='white' />
          <rect width='40' height='40' rx='20' fill='#F3F4F6' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M25.6271 20C25.6271 20.255 25.6046 20.495 25.5746 20.735L27.1571 21.9725C27.2996 22.085 27.3371 22.2875 27.2471 22.4525L25.7471 25.0475C25.6796 25.1675 25.5521 25.235 25.4246 25.235C25.3796 25.235 25.3346 25.2275 25.2896 25.2125L23.4221 24.4625C23.0321 24.755 22.6121 25.01 22.1546 25.1975L21.8696 27.185C21.8471 27.365 21.6896 27.5 21.5021 27.5H18.5021C18.3146 27.5 18.1571 27.365 18.1346 27.185L17.8496 25.1975C17.3921 25.01 16.9721 24.7625 16.5821 24.4625L14.7146 25.2125C14.6771 25.2275 14.6321 25.235 14.5871 25.235C14.4521 25.235 14.3246 25.1675 14.2571 25.0475L12.7571 22.4525C12.6671 22.2875 12.7046 22.085 12.8471 21.9725L14.4296 20.735C14.3996 20.495 14.3771 20.2475 14.3771 20C14.3771 19.7525 14.3996 19.505 14.4296 19.265L12.8471 18.0275C12.7046 17.915 12.6596 17.7125 12.7571 17.5475L14.2571 14.9525C14.3246 14.8325 14.4521 14.765 14.5796 14.765C14.6246 14.765 14.6696 14.7725 14.7146 14.7875L16.5821 15.5375C16.9721 15.245 17.3921 14.99 17.8496 14.8025L18.1346 12.815C18.1571 12.635 18.3146 12.5 18.5021 12.5H21.5021C21.6896 12.5 21.8471 12.635 21.8696 12.815L22.1546 14.8025C22.6121 14.99 23.0321 15.2375 23.4221 15.5375L25.2896 14.7875C25.3271 14.7725 25.3721 14.765 25.4171 14.765C25.5521 14.765 25.6796 14.8325 25.7471 14.9525L27.2471 17.5475C27.3371 17.7125 27.2996 17.915 27.1571 18.0275L25.5746 19.265C25.6046 19.505 25.6271 19.745 25.6271 20ZM24.127 20C24.127 19.8425 24.1195 19.685 24.0895 19.4525L23.9845 18.605L24.652 18.08L25.4545 17.4425L24.9295 16.535L23.977 16.9175L23.182 17.24L22.4995 16.715C22.1995 16.49 21.8995 16.3175 21.577 16.1825L20.782 15.86L20.662 15.0125L20.5195 14H19.477L19.327 15.0125L19.207 15.86L18.412 16.1825C18.1045 16.31 17.797 16.49 17.4745 16.73L16.7995 17.24L16.0195 16.925L15.067 16.5425L14.542 17.45L15.352 18.08L16.0195 18.605L15.9145 19.4525C15.892 19.6775 15.877 19.85 15.877 20C15.877 20.15 15.892 20.3225 15.9145 20.555L16.0195 21.4025L15.352 21.9275L14.542 22.5575L15.067 23.465L16.0195 23.0825L16.8145 22.76L17.497 23.285C17.797 23.51 18.097 23.6825 18.4195 23.8175L19.2145 24.14L19.3345 24.9875L19.477 26H20.527L20.677 24.9875L20.797 24.14L21.592 23.8175C21.8995 23.69 22.207 23.51 22.5295 23.27L23.2045 22.76L23.9845 23.075L24.937 23.4575L25.462 22.55L24.652 21.92L23.9845 21.395L24.0895 20.5475C24.112 20.3225 24.127 20.1575 24.127 20ZM20.0022 17C18.3447 17 17.0022 18.3425 17.0022 20C17.0022 21.6575 18.3447 23 20.0022 23C21.6597 23 23.0022 21.6575 23.0022 20C23.0022 18.3425 21.6597 17 20.0022 17ZM18.5022 20C18.5022 20.825 19.1772 21.5 20.0022 21.5C20.8272 21.5 21.5022 20.825 21.5022 20C21.5022 19.175 20.8272 18.5 20.0022 18.5C19.1772 18.5 18.5022 19.175 18.5022 20Z'
            fill='#696F88'
          />
        </g>
        <defs>
          <clipPath id='clip0_761_49394'>
            <rect width='40' height='40' rx='20' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={SettingsSVG} {...props} />;
};

export const HelpIcon = (props: Partial<CustomIconComponentProps>) => {
  const HelpSVG = () => {
    return (
      <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_761_49393)'>
          <rect width='40' height='40' rx='20' fill='white' />
          <rect width='40' height='40' rx='20' fill='#F3F4F6' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.5 20C12.5 15.86 15.86 12.5 20 12.5C24.14 12.5 27.5 15.86 27.5 20C27.5 24.14 24.14 27.5 20 27.5C15.86 27.5 12.5 24.14 12.5 20ZM20.75 23V24.5H19.25V23H20.75ZM20 26C16.6925 26 14 23.3075 14 20C14 16.6925 16.6925 14 20 14C23.3075 14 26 16.6925 26 20C26 23.3075 23.3075 26 20 26ZM17 18.5C17 16.8425 18.3425 15.5 20 15.5C21.6575 15.5 23 16.8425 23 18.5C23 19.4622 22.4075 19.98 21.8306 20.4842C21.2833 20.9624 20.75 21.4285 20.75 22.25H19.25C19.25 20.884 19.9566 20.3424 20.5778 19.8663C21.0652 19.4927 21.5 19.1594 21.5 18.5C21.5 17.675 20.825 17 20 17C19.175 17 18.5 17.675 18.5 18.5H17Z'
            fill='#696F88'
          />
        </g>
        <defs>
          <clipPath id='clip0_761_49393'>
            <rect width='40' height='40' rx='20' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={HelpSVG} {...props} />;
};

export const FileIcon = (props: Partial<CustomIconComponentProps>) => {
  const FileSVG = () => {
    return (
      <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g clipPath='url(#clip0_761_49392)'>
          <rect width='40' height='40' rx='20' fill='white' />
          <rect width='40' height='40' rx='20' fill='#F3F4F6' />
          <path
            d='M21.6275 14.75L25.25 18.3725V25.25H14.75V14.75H21.6275ZM21.6275 13.25H14.75C13.925 13.25 13.25 13.925 13.25 14.75V25.25C13.25 26.075 13.925 26.75 14.75 26.75H25.25C26.075 26.75 26.75 26.075 26.75 25.25V18.3725C26.75 17.975 26.5925 17.5925 26.3075 17.315L22.685 13.6925C22.4075 13.4075 22.025 13.25 21.6275 13.25ZM16.25 22.25H23.75V23.75H16.25V22.25ZM16.25 19.25H23.75V20.75H16.25V19.25ZM16.25 16.25H21.5V17.75H16.25V16.25Z'
            fill='#696F88'
          />
        </g>
        <defs>
          <clipPath id='clip0_761_49392'>
            <rect width='40' height='40' rx='20' fill='white' />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={FileSVG} {...props} />;
};

export const MapMarkerIcon = (props: Partial<CustomIconComponentProps>) => {
  const MapMarkerSVG = () => {
    return (
      <svg
        width='25'
        height='24'
        viewBox='0 0 25 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12.832 2C8.96203 2 5.83203 5.13 5.83203 9C5.83203 14.25 12.832 22 12.832 22C12.832 22 19.832 14.25 19.832 9C19.832 5.13 16.702 2 12.832 2ZM7.83203 9C7.83203 6.24 10.072 4 12.832 4C15.592 4 17.832 6.24 17.832 9C17.832 11.88 14.952 16.19 12.832 18.88C10.752 16.21 7.83203 11.85 7.83203 9ZM10.332 9C10.332 7.61929 11.4513 6.5 12.832 6.5C13.7252 6.5 14.5505 6.9765 14.9971 7.75C15.4437 8.5235 15.4437 9.4765 14.9971 10.25C14.5505 11.0235 13.7252 11.5 12.832 11.5C11.4513 11.5 10.332 10.3807 10.332 9Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={MapMarkerSVG} {...props} />;
};

export const TrophyIcon = (props: Partial<CustomIconComponentProps>) => {
  const TrophySVG = () => {
    return (
      <svg
        width='25'
        height='24'
        viewBox='0 0 25 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M19.5 5H17.5V3H7.5V5H5.5C4.4 5 3.5 5.9 3.5 7V8C3.5 10.55 5.42 12.63 7.89 12.94C8.52 14.44 9.87 15.57 11.5 15.9V19H7.5V21H17.5V19H13.5V15.9C15.13 15.57 16.48 14.44 17.11 12.94C19.58 12.63 21.5 10.55 21.5 8V7C21.5 5.9 20.6 5 19.5 5ZM5.5 8V7H7.5V10.82C6.34 10.4 5.5 9.3 5.5 8ZM12.5 14C10.85 14 9.5 12.65 9.5 11V5H15.5V11C15.5 12.65 14.15 14 12.5 14ZM19.5 8C19.5 9.3 18.66 10.4 17.5 10.82V7H19.5V8Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={TrophySVG} {...props} />;
};

export const TasksIcon = (props: Partial<CustomIconComponentProps>) => {
  const TasksSVG = () => {
    return (
      <svg
        width='25'
        height='24'
        viewBox='0 0 25 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='checklist'>
          <path
            id='Vector'
            d='M22.334 7.00005H13.334V9.00005H22.334V7.00005ZM22.334 15.0001H13.334V17.0001H22.334V15.0001ZM5.87398 11.0001L2.33398 7.46005L3.74398 6.05005L5.86398 8.17005L10.104 3.93005L11.514 5.34005L5.87398 11.0001ZM5.87398 19.0001L2.33398 15.4601L3.74398 14.0501L5.86398 16.1701L10.104 11.9301L11.514 13.3401L5.87398 19.0001Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={TasksSVG} {...props} />;
};

export const BookIcon = (props: Partial<CustomIconComponentProps>) => {
  const BookSVG = () => {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 21 21'>
        <g
          fill='none'
          fillRule='evenodd'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        >
          <path d='M18.5 6.59q-2-1.09-4-1.09c-2 0-2.667.364-4 1.09v9.91q2-1 4-1c2 0 2.667.333 4 1z' />
          <path d='M16.556 7.788Q15.529 7.5 14.5 7.5c-1.029 0-1.37.096-2.056.288m4.112 2Q15.529 9.5 14.5 9.5c-1.029 0-1.37.096-2.056.288m4.112 2Q15.529 11.5 14.5 11.5c-1.029 0-1.37.096-2.056.288m4.112 2Q15.529 13.5 14.5 13.5c-1.029 0-1.37.096-2.056.288m-3.888-6Q7.529 7.5 6.5 7.5c-1.029 0-1.37.096-2.056.288m4.112 2Q7.529 9.5 6.5 9.5c-1.029 0-1.37.096-2.056.288m4.112 2Q7.529 11.5 6.5 11.5c-1.029 0-1.37.096-2.056.288m4.112 2Q7.529 13.5 6.5 13.5c-1.029 0-1.37.096-2.056.288' />
          <path d='M10.5 6.59q-2-1.09-4-1.09c-2 0-2.667.364-4 1.09v9.91q2-1 4-1c2 0 2.667.333 4 1z' />
        </g>
      </svg>
    );
  };
  return <Icon component={BookSVG} {...props} />;
};
export const InfoIcon = (props: Partial<CustomIconComponentProps>) => {
  const InfoSVG = () => {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 64 64'>
        <path
          fill='currentColor'
          d='M32 2C15.432 2 2 15.432 2 32s13.432 30 30 30s30-13.432 30-30S48.568 2 32 2m5 49.75H27v-24h10zm-5-29.5a5 5 0 1 1 0-10a5 5 0 0 1 0 10'
        />
      </svg>
    );
  };
  return <Icon component={InfoSVG} {...props} />;
};

export const GrayOutlineInfoIcon = (props: IconProps) => {
  const InfoSVG = () => {
    return (
      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        data-testid='gray-outline-info-icon'
      >
        <g id='info'>
          <path
            id='icon/action/info_24px'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.9987 1.33301C4.3187 1.33301 1.33203 4.31967 1.33203 7.99967C1.33203 11.6797 4.3187 14.6663 7.9987 14.6663C11.6787 14.6663 14.6654 11.6797 14.6654 7.99967C14.6654 4.31967 11.6787 1.33301 7.9987 1.33301ZM7.33203 4.66634V5.99967H8.66536V4.66634H7.33203ZM7.33203 7.33301V11.333H8.66536V7.33301H7.33203ZM2.66536 7.99967C2.66536 10.9397 5.0587 13.333 7.9987 13.333C10.9387 13.333 13.332 10.9397 13.332 7.99967C13.332 5.05967 10.9387 2.66634 7.9987 2.66634C5.0587 2.66634 2.66536 5.05967 2.66536 7.99967Z'
            fill='currentColor'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={InfoSVG} {...props} />;
};

export const PdfIcon = (props: Partial<CustomIconComponentProps>) => {
  const PdfSVG = () => {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 32 32'>
        <path fill='#909090' d='m24.1 2.072l5.564 5.8v22.056H8.879V30h20.856V7.945z' />
        <path fill='#f4f4f4' d='M24.031 2H8.808v27.928h20.856V7.873z' />
        <path fill='#7a7b7c' d='M8.655 3.5h-6.39v6.827h20.1V3.5z' />
        <path fill='#dd2025' d='M22.472 10.211H2.395V3.379h20.077z' />
        <path
          fill='#464648'
          d='M9.052 4.534H7.745v4.8h1.028V7.715L9 7.728a2 2 0 0 0 .647-.117a1.4 1.4 0 0 0 .493-.291a1.2 1.2 0 0 0 .335-.454a2.1 2.1 0 0 0 .105-.908a2.2 2.2 0 0 0-.114-.644a1.17 1.17 0 0 0-.687-.65a2 2 0 0 0-.409-.104a2 2 0 0 0-.319-.026m-.189 2.294h-.089v-1.48h.193a.57.57 0 0 1 .459.181a.92.92 0 0 1 .183.558c0 .246 0 .469-.222.626a.94.94 0 0 1-.524.114m3.671-2.306c-.111 0-.219.008-.295.011L12 4.538h-.78v4.8h.918a2.7 2.7 0 0 0 1.028-.175a1.7 1.7 0 0 0 .68-.491a1.9 1.9 0 0 0 .373-.749a3.7 3.7 0 0 0 .114-.949a4.4 4.4 0 0 0-.087-1.127a1.8 1.8 0 0 0-.4-.733a1.6 1.6 0 0 0-.535-.4a2.4 2.4 0 0 0-.549-.178a1.3 1.3 0 0 0-.228-.017m-.182 3.937h-.1V5.392h.013a1.06 1.06 0 0 1 .6.107a1.2 1.2 0 0 1 .324.4a1.3 1.3 0 0 1 .142.526c.009.22 0 .4 0 .549a3 3 0 0 1-.033.513a1.8 1.8 0 0 1-.169.5a1.1 1.1 0 0 1-.363.36a.67.67 0 0 1-.416.106m5.08-3.915H15v4.8h1.028V7.434h1.3v-.892h-1.3V5.43h1.4v-.892'
        />
        <path
          fill='#dd2025'
          d='M21.781 20.255s3.188-.578 3.188.511s-1.975.646-3.188-.511m-2.357.083a7.5 7.5 0 0 0-1.473.489l.4-.9c.4-.9.815-2.127.815-2.127a14 14 0 0 0 1.658 2.252a13 13 0 0 0-1.4.288Zm-1.262-6.5c0-.949.307-1.208.546-1.208s.508.115.517.939a10.8 10.8 0 0 1-.517 2.434a4.4 4.4 0 0 1-.547-2.162Zm-4.649 10.516c-.978-.585 2.051-2.386 2.6-2.444c-.003.001-1.576 3.056-2.6 2.444M25.9 20.895c-.01-.1-.1-1.207-2.07-1.16a14 14 0 0 0-2.453.173a12.5 12.5 0 0 1-2.012-2.655a11.8 11.8 0 0 0 .623-3.1c-.029-1.2-.316-1.888-1.236-1.878s-1.054.815-.933 2.013a9.3 9.3 0 0 0 .665 2.338s-.425 1.323-.987 2.639s-.946 2.006-.946 2.006a9.6 9.6 0 0 0-2.725 1.4c-.824.767-1.159 1.356-.725 1.945c.374.508 1.683.623 2.853-.91a23 23 0 0 0 1.7-2.492s1.784-.489 2.339-.623s1.226-.24 1.226-.24s1.629 1.639 3.2 1.581s1.495-.939 1.485-1.035'
        />
        <path fill='#909090' d='M23.954 2.077V7.95h5.633z' />
        <path fill='#f4f4f4' d='M24.031 2v5.873h5.633z' />
        <path
          fill='#fff'
          d='M8.975 4.457H7.668v4.8H8.7V7.639l.228.013a2 2 0 0 0 .647-.117a1.4 1.4 0 0 0 .493-.291a1.2 1.2 0 0 0 .332-.454a2.1 2.1 0 0 0 .105-.908a2.2 2.2 0 0 0-.114-.644a1.17 1.17 0 0 0-.687-.65a2 2 0 0 0-.411-.105a2 2 0 0 0-.319-.026m-.189 2.294h-.089v-1.48h.194a.57.57 0 0 1 .459.181a.92.92 0 0 1 .183.558c0 .246 0 .469-.222.626a.94.94 0 0 1-.524.114m3.67-2.306c-.111 0-.219.008-.295.011l-.235.006h-.78v4.8h.918a2.7 2.7 0 0 0 1.028-.175a1.7 1.7 0 0 0 .68-.491a1.9 1.9 0 0 0 .373-.749a3.7 3.7 0 0 0 .114-.949a4.4 4.4 0 0 0-.087-1.127a1.8 1.8 0 0 0-.4-.733a1.6 1.6 0 0 0-.535-.4a2.4 2.4 0 0 0-.549-.178a1.3 1.3 0 0 0-.228-.017m-.182 3.937h-.1V5.315h.013a1.06 1.06 0 0 1 .6.107a1.2 1.2 0 0 1 .324.4a1.3 1.3 0 0 1 .142.526c.009.22 0 .4 0 .549a3 3 0 0 1-.033.513a1.8 1.8 0 0 1-.169.5a1.1 1.1 0 0 1-.363.36a.67.67 0 0 1-.416.106m5.077-3.915h-2.43v4.8h1.028V7.357h1.3v-.892h-1.3V5.353h1.4v-.892'
        />
      </svg>
    );
  };
  return <Icon component={PdfSVG} {...props} />;
};

export const PptIcon = (props: Partial<CustomIconComponentProps>) => {
  const PptSVG = () => {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 24 24'>
        <g
          fill='none'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        >
          <path d='M14 3v4a1 1 0 0 0 1 1h4' />
          <path d='M14 3v4a1 1 0 0 0 1 1h4M5 18h1.5a1.5 1.5 0 0 0 0-3H5v6m6-3h1.5a1.5 1.5 0 0 0 0-3H11v6m5.5-6h3M18 15v6' />
          <path d='M5 12V5a2 2 0 0 1 2-2h7l5 5v4' />
        </g>
      </svg>
    );
  };
  return <Icon component={PptSVG} {...props} />;
};

export const UserManualIcon = (props: IconProps) => {
  const UserManualIconSVG = () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM14.1004 7.99844C14.1004 6.83844 13.1604 5.89844 12.0004 5.89844C10.8404 5.89844 9.90039 6.83844 9.90039 7.99844C9.90039 9.15844 10.8404 10.0984 12.0004 10.0984C13.1604 10.0984 14.1004 9.15844 14.1004 7.99844ZM18.1004 16.9984C18.1004 16.3584 14.9704 14.8984 12.0004 14.8984C9.03039 14.8984 5.90039 16.3584 5.90039 16.9984V18.0984H18.1004V16.9984ZM4 17C4 14.34 9.33 13 12 13C14.67 13 20 14.34 20 17V20H4V17Z'
          fill='#696F88'
        />
      </svg>
    );
  };
  return <Icon component={UserManualIconSVG} {...props} />;
};

export const FAQIcon = (props: IconProps) => {
  const FAQIconSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left-24px'>
          <path
            id='help_outline'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM13 16V18H11V16H13ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM8 10C8 7.79 9.79 6 12 6C14.21 6 16 7.79 16 10C16 11.2829 15.21 11.9733 14.4408 12.6455C13.711 13.2833 13 13.9046 13 15H11C11 13.1787 11.9421 12.4566 12.7704 11.8217C13.4202 11.3236 14 10.8792 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10H8Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={FAQIconSVG} {...props} />;
};

export const TeamsIcon = (props: IconProps) => {
  const TeamsIconSVG = () => {
    return (
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='icon-left-24px'>
          <path
            id='people'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM2 17.25C2 14.92 6.66 13.75 9 13.75C11.34 13.75 16 14.92 16 17.25V19H2V17.25ZM9 15.75C7.21 15.75 5.18 16.42 4.34 17H13.66C12.82 16.42 10.79 15.75 9 15.75ZM10.5 8.5C10.5 7.67 9.83 7 9 7C8.17 7 7.5 7.67 7.5 8.5C7.5 9.33 8.17 10 9 10C9.83 10 10.5 9.33 10.5 8.5ZM16.04 13.8086C17.2 14.6486 18 15.7686 18 17.2486V18.9986H22V17.2486C22 15.2286 18.5 14.0786 16.04 13.8086ZM18.5 8.5C18.5 10.43 16.93 12 15 12C14.46 12 13.96 11.87 13.5 11.65C14.13 10.76 14.5 9.67 14.5 8.5C14.5 7.33 14.13 6.24 13.5 5.35C13.96 5.13 14.46 5 15 5C16.93 5 18.5 6.57 18.5 8.5Z'
            fill='#696F88'
          />
        </g>
      </svg>
    );
  };
  return <Icon component={TeamsIconSVG} {...props} />;
};
